// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-forms-input-module__error--BullU {
  border-color: #ff0000;
}

.src-js-components-forms-input-module__inputPrimary--j3zfV {
  background-color: #a8b0b8;
  color: #ffffff;
  border: 1px solid #ffffff;
  text-align: left;
}

.src-js-components-forms-input-module__inputPrimary--j3zfV::placeholder {
  color: #ffffff;
  font-style: italic;
}

.src-js-components-forms-input-module__inputPrimary--j3zfV:-ms-input-placeholder {
  color: #ffffff;
  font-style: italic;
}

.src-js-components-forms-input-module__inputPrimary--j3zfV::-ms-input-placeholder {
  color: #ffffff;
  font-style: italic;
}

.src-js-components-forms-input-module__inputPrimary--j3zfV.src-js-components-forms-input-module__error--BullU {
  border-color: #ff0000;
}

.src-js-components-forms-input-module__disabled--HpT73,
fieldset[disabled] input {
  color: #8a8a8a;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/forms/input.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".error {\n  border-color: #ff0000;\n}\n\n.inputPrimary {\n  background-color: #a8b0b8;\n  color: #ffffff;\n  border: 1px solid #ffffff;\n  text-align: left;\n}\n\n.inputPrimary::placeholder {\n  color: #ffffff;\n  font-style: italic;\n}\n\n.inputPrimary:-ms-input-placeholder {\n  color: #ffffff;\n  font-style: italic;\n}\n\n.inputPrimary::-ms-input-placeholder {\n  color: #ffffff;\n  font-style: italic;\n}\n\n.inputPrimary.error {\n  border-color: #ff0000;\n}\n\n.disabled,\nfieldset[disabled] input {\n  color: #8a8a8a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `src-js-components-forms-input-module__error--BullU`,
	"inputPrimary": `src-js-components-forms-input-module__inputPrimary--j3zfV`,
	"disabled": `src-js-components-forms-input-module__disabled--HpT73`
};
export default ___CSS_LOADER_EXPORT___;
